import { withNamespaces } from "react-i18next";
import { Alert, Col, Container, Row } from "reactstrap";
import Navigator from "src/components/navigator";
import ListProducts from "./components/list-products";
import { useQuery } from "@tanstack/react-query";
import { connect } from "react-redux";
import SupplierService from 'src/modules/3rd-party-management/apis/thirdparty/SupplierService';
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { isFeatureEnabledForActiveModule } from "src/helpers/module_helper";

const EudrDueDiligence = ({ t, Organization }) => {
    const history = useHistory();

    const {
        data: openReportRequestData,
        isFetching: fetchingReportRequestsInProcess
    } = useQuery({
        queryKey: [
            '3rd-party-management-fetch-supplier-report-requests',
            'eudr',
            Organization.id
        ],
        queryFn: async () => {
            const service = SupplierService.getInstance();

            return await service.fetchUserReportRequests();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: isFeatureEnabledForActiveModule('eudr_activation'),
        retry: 0,
        onError: ({
            response
        }) => {
            if (response.data.error === 'report_request_list_empty') {
                toast(t('It is not possible to send a report before the request is created by admin'), {
                    type: 'error'
                });
            }
            else {
                toast(t('An error occurred while starting!'), {
                    type: 'error'
                });
            }

            history.push('/third-party/3rd-party/home');
        }
    });

    return (
        <div className='page-content thirdparty-questionnaire'>
            <Container fluid>
                <Row>
                    <Col sm='12'>
                        <Navigator
                            breadCrumbs={[
                                {
                                    title: 'SIP',
                                    link: '/third-party/3rd-party/home'
                                },
                                {
                                    title: t('My reports'),
                                    link: '/third-party/3rd-party/reports'
                                },
                                {
                                    title: t('EUDR Due Diligence'),
                                    link: '#'
                                }
                            ]}
                            pageTitle={t('EUDR Due Diligence Report')}
                        />
                    </Col>
                </Row>

                {isFeatureEnabledForActiveModule('eudr_activation') ? (
                    !fetchingReportRequestsInProcess && openReportRequestData?.request?.id ? (
                        <ListProducts 
                            openReportRequest={openReportRequestData}
                        /> 
                    ) : (
                        <p className='text-center'>{t('Please wait')}...</p>
                    )
                ) : (
                    <Alert color="warning">
                        <p className="mb-0">
                            {t("Please upgrade your plan to access this feature")}
                        </p>
                    </Alert>
                )}
            </Container>
        </div>
    )
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
	const { Organization } = state;
	
	return {
		Organization,
        token
	};
};

export default withNamespaces()(
	connect(mapStatetoProps)(
        EudrDueDiligence
    )
);